import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedCreditDispensationListViewList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface IUseCreditDispensations {
  athleteId?: string;
  validityDate?: string;
}

interface QueryKeyType {
  pageParam?: UrlParams;
}

function useCreditDispensations({
  athleteId,
  validityDate,
}: IUseCreditDispensations): UseInfiniteQueryResult<AxiosResponse<PaginatedCreditDispensationListViewList>> {
  const fetchCreditDispensations = useCallback(
    ({
      pageParam = { limit: '20', offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedCreditDispensationListViewList>> => {
      const params = pageParam;
      if (athleteId !== undefined) {
        params.athlete = athleteId;
      }
      if (validityDate) {
        params.valid_on = validityDate;
      }
      return client.get(`credit-dispensations/?${encodeUrlParams(pageParam)}`);
    },
    [validityDate, athleteId],
  );

  return useInfiniteQuery(['creditDispensations', athleteId, validityDate], fetchCreditDispensations, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
    enabled: !!athleteId,
  });
}

export default useCreditDispensations;
